import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { allSharedComponents } from "../../../../../shared";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import { competitionActions } from "../../../../../redux/actions";
import cancelIcon from "../../../../../assets/images/icon/crossIcon.svg";
import {
  modeConstants,
  translationConstants,
  Directions,
  TableColumnStyle,
  genderEnumReversed,
  levelEnumReversed,
} from "../../../../../constants";
import {
  changeTableSortIcons,
  getSortDirectionProperty,
  removeSpace,
  copyToClipboard,
} from "../../../../../system";
import CompetitionScoreModal from "../../../../../shared/components/Modals/CompetitionModal";
import UploadResultsModal from "../../../../../shared/components/Modals/UploadResultsModal";
import { debounce } from "@mui/material";
import BaseForm from "../../../../../shared/components/BaseForm/BaseForm";
import CompetitionsFeedbackForm from "../../../../../container/views/Competitions/CompetitionFeedback/CompetitionFeedbackForm";
import Tooltip from "@mui/material/Tooltip";
import {
  SearchBoxIcon,
  UploadIcon,
} from "../../../../../assets/images/icon/iconsProvider";

const { DataTable, PublishModal, CustomModal } = allSharedComponents;
const defaultQueryExpression = "isActive == true ";
const initialGridState = {
  length: 10,
  pageNumber: 1,
  orderBy: "ranking asc",
  filterQuery: defaultQueryExpression,
  search: null,
};
const column = {
  genderBoatClass: "genderBoatClass.Id",
};

const ParticipantsTab = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const particaipantsPage = useSelector(
    (state) => state.CompetitionReducer.competitionParticipantsDetail.page
  );
  const feedbackData = useSelector(
    (state) => state.CompetitionReducer.competitionfeedback
  );
  const participantsPageData = useSelector(
    (state) =>
      state.CompetitionReducer.competitionParticipantsDetail.pageData
        ?.competitionParticipants
  );
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const competitionData = useSelector(
    (state) => state.CompetitionReducer.competitionGeneralDetail
  );

  const sortingInProgressRef = useRef(false);
  const [rowData, setRowData] = useState("");
  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(gridState.pageNumber);
  const [isShow, setIsShow] = useState(false);
  const [isSaveShow, setIsSaveShow] = useState(false);
  const [isFeedbackShow, setIsFeedbackShow] = useState(false);
  const [isUpdateScore, setIsUpdateScore] = useState(false);
  const [isUploadResult, setIsUploadResult] = useState(false);
  const [dataToPublish, setDataToPublish] = useState("");
  const [inputSearch, setInputSearch] = useState(null);
  const [boatClassFilter, setBoatClassFilter] = useState("");
  const searchInputRef = useRef(null);

  const publish = (id) => {
    dispatch(
      competitionActions.publishScore(
        id,
        competitionActions.getCompetitionParticipantsDetailById(
          props.id,
          gridState
        )
      )
    );
    setIsShow(!isShow);
  };

  const getRowData = (data) => {
    dispatch(competitionActions.getCompetitionFeedbackById(data.id));
    setIsFeedbackShow(true);
  };

  const getcolumns = () => {
    const columns = [
      {
        id: "id",
        accessor: "id",
        name: t(translationConstants.RECORD_ID),
        cell: (row) => (
          <Tooltip
            title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
            placement="top"
            arrow
          >
            <div
              className="truncate-text cursor-pointer"
              onClick={() => copyToClipboard(row.id)}
            >
              {row.id}
            </div>
          </Tooltip>
        ),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
        maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "name",
        name: t(translationConstants.name),
        selector: (row) =>
          direction === Directions.rtl
            ? removeSpace(row?.arabicName)
              ? row?.arabicName
              : row?.name
            : row?.name,
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_160,
      },
      {
        id: "email",
        name: t(translationConstants.Email),
        selector: (row) => row?.email,
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_160,
      },
      {
        id: "gender",
        name: t(translationConstants.gender),
        selector: (row) =>
          t(translationConstants[genderEnumReversed[row?.gender]]),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "levelId",
        name: t(translationConstants.LEVEL),
        selector: (row) =>
          t(translationConstants[levelEnumReversed[row.levelId]]),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "isMembershipHolder",
        name: t(translationConstants.IS_MEMBER),
        selector: (row) =>
          row?.isMembershipHolder
            ? t(translationConstants.YES)
            : t(translationConstants.NO),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_140,
      },
      {
        id: "fee",
        name: t(translationConstants.FEES),
        selector: (row) => row.fee,
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "genderBoatClass",
        name: t(translationConstants.BOAT_CLASS),
        selector: (row) => {
          const name =
            direction === Directions.rtl && row?.genderBoatClass?.arabicName
              ? row?.genderBoatClass?.arabicName
              : row?.genderBoatClass?.name;
          const gender = t(
            translationConstants[
              genderEnumReversed[row?.genderBoatClass?.gender]
            ]
          );
          return `${name} - ${gender}`;
        },
        reorder: true,
        sortable: false,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_180,
      },
      {
        id: "ranking",
        name: t(translationConstants.RANKING),
        selector: (row) => (row.ranking ? row.ranking : "--"),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "points",
        name: t(translationConstants.SCORE),
        selector: (row) => (row.points ? row.points : "--"),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
    ];
    if (props.isScorePublished) {
      columns.push({
        id: "averageScore",
        name: t(translationConstants.FEEDBACK),
        selector: (row) => (row.averageScore ? row.averageScore : "--"),
        reorder: true,
        sortable: true,
        sortDirection: null,
        cell: (row) => {
          return (
            <p
              onClick={() => {
                if (row.averageScore) {
                  getRowData(row);
                }
              }}
              className={`approved-color ${
                row.averageScore ? "underline fw-2 cursor-pointer" : ""
              }`}
            >
              {row.averageScore ? row.averageScore : "--"}
            </p>
          );
        },
      });
    }

    return columns;
  };

  const [columns, setColumns] = useState(getcolumns());

  const onSort = (sortedColumn) => {
    sortingInProgressRef.current = true;
    setColumns(changeTableSortIcons(columns, sortedColumn));
    const columnDirection = getSortDirectionProperty(sortedColumn);
    setDefaultPage(gridState.pageNumber);
    const orderBy =
      columnDirection !== null
        ? `${sortedColumn.id} ${columnDirection}`
        : "ranking asc";
    setGridState((prevState) => ({
      ...prevState,
      orderBy: orderBy,
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  useEffect(() => {
    if (participantsPageData !== null) {
      setRowData(participantsPageData);
    }
    // eslint-disable-next-line
  }, [participantsPageData]);

  useEffect(() => {
    setColumns(getcolumns());
    // eslint-disable-next-line
  }, [i18n.dir()]);

  useEffect(() => {
    dispatch(
      competitionActions.getCompetitionParticipantsDetailById(
        props.id,
        gridState
      )
    );
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  const uploadResults = () => {
    dispatch(competitionActions.getUploadedFile(props.id, setIsUploadResult));
    // setIsUploadResult(!isUploadResult)
  };

  const buildFilterQuery = () => {
    let filterQueryExpression = defaultQueryExpression;
    if (boatClassFilter) {
      filterQueryExpression += `&& ${column.genderBoatClass} == \"${boatClassFilter}\"`;
    }
    return filterQueryExpression;
  };

  const onFilterChange = useCallback((key, value) => {
    switch (key) {
      case column.genderBoatClass:
        setBoatClassFilter(value);
        break;
      case column.search:
        setInputSearch(value);
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    const filterQueryExpression = buildFilterQuery();
    setGridState((prevState) => ({
      ...prevState,
      filterQuery: filterQueryExpression,
      search: inputSearch,
    }));
    // eslint-disable-next-line
  }, [inputSearch, boatClassFilter]);

  const handleSearch = debounce((value) => {
    setInputSearch(value);
  }, process.env.REACT_APP_SEARCH_DEBOUNCE_INTERVAL);

  const handleResetSearch = () => {
    searchInputRef.current.value = "";
    setInputSearch("");
  };

  const handleClearFilters = () => {
    setBoatClassFilter("");
    setGridState({
      ...gridState,
      filterQuery: defaultQueryExpression,
    });
  };

  return (
    <>
      <div className="tableContainer">
        <Container className="m-0 p-0 mw-100">
          <Row className="mt-2 mb-3">
            <Col
              md="3"
              xs="12"
              className="d-flex justify-content-sm-start justify-content-center align-items-center"
            >
              <div className="searchInputDiv gap-2 d-flex justify-content-center align-items-center w-100">
                <div>
                  <SearchBoxIcon />
                </div>
                <input
                  className="searchInput w-100"
                  type="text"
                  placeholder={t(translationConstants.Search)}
                  onChange={(e) => handleSearch(e.target.value)}
                  ref={searchInputRef}
                />
                {inputSearch && (
                  <div
                    onClick={handleResetSearch}
                    className="cross cursor-pointer"
                  >
                    <img width={16} src={cancelIcon} alt="cancel icon" />
                  </div>
                )}
              </div>
            </Col>
            <Col
              md="2"
              xs="12"
              className="d-flex justify-content-center align-items-center mt-3 mt-md-0 px-md-2 py-md-0"
            >
              <Form.Select
                className="custom-select-icon filter-style"
                aria-label="Default select example"
                value={boatClassFilter}
                onChange={(event) =>
                  onFilterChange(column.genderBoatClass, event.target.value)
                }
              >
                <option value="">
                  {t(translationConstants.ALL_BOAT_CLASS)}
                </option>
                {competitionData?.classes?.map((object) => {
                  const name =
                    direction === Directions.rtl && object.arabicName
                      ? object.arabicName
                      : object.name;
                  const genderText = t(
                    translationConstants[genderEnumReversed[object.gender]]
                  );
                  return (
                    <option
                      key={object.id}
                      value={object.id}
                      className="capitalize-first"
                    >
                      {`${name} - ${genderText}`}
                    </option>
                  );
                })}
              </Form.Select>
            </Col>
            <Col
              md="1"
              xs="12"
              className="d-flex justify-content-md-end justify-content-center"
            >
              {boatClassFilter && (
                <div className="cancel-filter" onClick={handleClearFilters}>
                  {t(translationConstants.CLEAR_FILTERS)}
                </div>
              )}
            </Col>
            <Col
              md="7"
              lg="6"
              xs="12"
              className="d-flex justify-content-md-end justify-content-center"
            >
              {!props.isScorePublished && (
                <Row className="">
                  {props.isScoreUpdated && (
                    <Col
                      sm="4"
                      xs="12"
                      className="d-flex justify-content-md-end justify-content-center align-items-center mt-4 mt-md-0"
                    >
                      <span
                        className="d-flex align-items-center"
                        onClick={() => uploadResults()}
                      >
                        <UploadIcon />
                        &nbsp;
                        <label className="upload-result-text">
                          {t(translationConstants.UPLOAD_RESULTS)}
                        </label>
                      </span>
                    </Col>
                  )}

                  <Col
                    sm="4"
                    xs="12"
                    className="mt-4 mt-md-0 px-2 d-flex justify-content-center align-items-center"
                  >
                    <Button
                      className="btn-submit min-width-btn"
                      type="submit"
                      onClick={() => {
                        setIsUpdateScore(!isUpdateScore);
                      }}
                      disabled={participantsPageData?.length === 0}
                    >
                      {t(translationConstants.UPDATE_SCORE)}
                    </Button>
                  </Col>

                  {props.isScoreUpdated && (
                    <Col
                      sm="4"
                      xs="12"
                      className="mt-4 mt-md-0 px-2 d-flex justify-content-center align-items-center"
                    >
                      <Button
                        className="btn-submit min-width-btn"
                        type="submit"
                        onClick={() => {
                          setDataToPublish(props.id);
                          setIsShow(!isShow);
                        }}
                      >
                        {t(translationConstants.PUBLISH_SCORE)}
                      </Button>
                    </Col>
                  )}
                </Row>
              )}
            </Col>
          </Row>
        </Container>

        <DataTable
          columns={columns}
          items={rowData}
          onSort={onSort}
          gridState={gridState}
          paginationTotalRows={particaipantsPage?.totalElements}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          paginationDefaultPage={defaultPage}
          paginationResetDefaultPage={true}
        />

        <CustomModal
          scrollable={true}
          size="md"
          setShow={setIsShow}
          show={isShow}
          customClass="view-user-modal"
        >
          <PublishModal
            title={t(translationConstants.PUBLISH_SCORE_TITLE)}
            message={t(translationConstants.PUBLISH_SCORE_TEXT)}
            publishScore={publish}
            isButtonsDisplay={true}
            dataToPublish={dataToPublish}
            onCancel={() => setIsShow(!isShow)}
          />
        </CustomModal>

        <CustomModal
          scrollable={true}
          size="md"
          setShow={setIsSaveShow}
          show={isSaveShow}
          customClass="view-user-modal"
        >
          <PublishModal
            title={t(translationConstants.SAVE_SCORE_TITLE)}
            message={t(translationConstants.SAVE_SCORE_TEXT)}
            isButtonsDisplay={false}
            onCancel={() => setIsSaveShow(!isSaveShow)}
          />
        </CustomModal>

        <CustomModal
          scrollable={true}
          size="lg"
          setShow={setIsUpdateScore}
          show={isUpdateScore}
          customClass="view-user-modal"
          onCancel={() => setIsUpdateScore(!isUpdateScore)}
        >
          <CompetitionScoreModal
            title={t(translationConstants.UPDATE_COMPETITION_SCORE)}
            defaultGridState={gridState}
            setShow={setIsUpdateScore}
            show={isUpdateScore}
            setIsSaveShow={setIsSaveShow}
            onCancel={() => setIsUpdateScore(!isUpdateScore)}
            id={props.id}
          />
        </CustomModal>

        <CustomModal
          scrollable={true}
          size="md"
          setShow={setIsUploadResult}
          show={isUploadResult}
          customClass="view-user-modal"
          onCancel={() => setIsUpdateScore(!isUpdateScore)}
        >
          <UploadResultsModal
            title={t(translationConstants.UPLOAD_RESULTS)}
            setShow={setIsUploadResult}
            show={isUploadResult}
            id={props.id}
          />
        </CustomModal>
        <CustomModal
          size="lg"
          show={isFeedbackShow}
          scrollable={true}
          setShow={setIsFeedbackShow}
        >
          <BaseForm>
            <CompetitionsFeedbackForm
              setShow={setIsFeedbackShow}
              feedbackData={feedbackData}
              mode={modeConstants.VIEW_MODE}
            />
          </BaseForm>
        </CustomModal>
      </div>
    </>
  );
};

export default ParticipantsTab;
